<script lang="ts">
    import { formatCurrency } from '$saga/utils/price';
    import { selectedPrice } from '$saga/views/Tour/store';

    export let originalPrice: string,
        rebateAmount: string,
        minPrice: number,
        dict: any;
</script>

<div class="flex w-full flex-col desktop:gap-xs">
    <div class="flex flex-wrap items-center gap-xs">
        {#if $selectedPrice.rebateAmount == null && $selectedPrice.originalPrice == null && $selectedPrice.actualPrice == null}
            <div class="text-sm font-semibold desktop:text-[22px]">
                {dict.minPrice}
            </div>
        {/if}
        {#if $selectedPrice.originalPrice != null && $selectedPrice.rebateAmount != null}
            <div class="text-[20px] font-semibold line-through">
                {$selectedPrice.originalPrice
                    ? formatCurrency($selectedPrice.originalPrice)
                    : formatCurrency(parseFloat(originalPrice))}
            </div>
            <div
                class="w-fit self-center bg-container-commercial-catchy p-2xs text-xs"
            >
                {$selectedPrice.rebateAmount ?? rebateAmount}
            </div>
        {:else if $selectedPrice.actualPrice == null && originalPrice && rebateAmount}
            <div class="text-sm line-through">
                {formatCurrency(parseFloat(originalPrice))}
            </div>
            <div
                class="w-fit self-center bg-container-commercial-catchy p-2xs text-sm"
            >
                {rebateAmount}
            </div>
        {/if}
    </div>

    <div class="text-base font-semibold desktop:text-[32px]">
        {formatCurrency($selectedPrice.actualPrice ?? minPrice)}
        <span class="text-xs font-normal desktop:text-base">{dict.byPers}</span>
    </div>
</div>
